/**
 * Afterpay Price Helper
 * -----------------------------------------------------------------------------
 * Calculates and formats the afterpay price (price divided by 4, rounded to 2 decimal places)
 */

import { formatMoney } from './currency-formatter'

/**
 * Calculate the afterpay price from a given price
 * @param price - Price as a string (e.g., "50.00" or "$50.00") or number
 * @returns Formatted afterpay price string (e.g., "$12.50") or null if invalid
 */
export function calculateAfterpayPrice(price: string | number | null | undefined): string | null {
  if (!price) return null

  const numericPrice = typeof price === 'string' ? parseFloat(price) : price
  if (isNaN(numericPrice)) return null

  const afterpayPriceValue = Math.round((numericPrice / 4) * 100) / 100

  const moneyFormat = window.globals?.shopify?.moneyFormat || '${{amount}}'
  const priceInCents = Math.round(afterpayPriceValue * 100)

  return formatMoney(priceInCents, moneyFormat)
}

/**
 * Replace the static price in afterpay messaging HTML with calculated price
 * @param html - The afterpay messaging HTML string
 * @param afterpayPrice - The calculated afterpay price to insert
 * @returns Updated HTML string with the calculated price
 */
export function replaceAfterpayPriceInHTML(html: string, afterpayPrice: string): string {
  if (!html || !afterpayPrice) return html

  return html.replace(/(4x payments of\s*)([<$£€]?)(\d+\.?\d*)/i, (match, prefix) => {
    return prefix + afterpayPrice
  })
}
